









'use strict';

var CancelAnimationFrame={
current:function current(id){return global.cancelAnimationFrame(id);},
inject:function inject(injected){
CancelAnimationFrame.current=injected;
}};


module.exports=CancelAnimationFrame;


/*****************
 ** WEBPACK FOOTER
 ** ./~/animated/lib/injectable/CancelAnimationFrame.js
 ** module id = 128
 ** module chunks = 0
 **/